<template>
  <div class="qianqing-product-update">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
      :page-size="10"
    >
      <template v-slot:catalogId="{ text }">
        {{ getCatalogName(text) }}
      </template>
      <template v-slot:lineTitle="{ text }">
        <a-tooltip :title="text">
          <div class="ellipsis-cell">{{ text }}</div>
        </a-tooltip>
      </template>
      <template v-slot:syncTime="{ text }">
        {{ formatSyncTime(text) }}
      </template>
      <template v-slot:action="{ record }">
        <a-space>
          <a class="action-block" @click="onToggleShield(record)">{{ record.shielded ? '解除屏蔽' : '屏蔽' }}</a>
          <a @click="onManualUpdate(record)">手动更新</a>
        </a-space>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import QianqingMixins from '@/views/resource/qianqing/mixins/QianqingMixins'

export default {
  name: 'ProductUpdateComponent',
  components: {
    StandardSearchPageView
  },
  mixins: [QianqingMixins],
  data () {
    const catalogOptions = (this.getAppConstants().getProductTypeList() || []).map(item => ({
      label: item.name,
      value: item.code
    }))
    return {
      catalogOptions,
      queryParams: {
        proId: '',
        lineCode: '',
        catalogId: undefined,
        syncDateStart: undefined,
        syncDateEnd: undefined
      },
      searchOptions: [
        {
          name: '商品ID',
          key: 'proId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '千擎资源ID',
          key: 'lineCode',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '商品分类',
          key: 'catalogId',
          type: 'select',
          placeholder: '请选择',
          selectOptions: catalogOptions
        },
        {
          name: '更新日期',
          key: 'syncDateStart,syncDateEnd',
          type: 'rangePicker'
        }
      ],
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: 100
        },
        {
          title: '千擎资源ID',
          dataIndex: 'lineCode',
          width: 120
        },
        {
          title: '千擎线路ID',
          dataIndex: 'lineId',
          width: 120
        },
        {
          title: '千擎线路标题',
          dataIndex: 'title',
          width: 480,
          scopedSlots: { customRender: 'lineTitle' }
        },
        {
          title: '商品分类',
          dataIndex: 'catalogId',
          width: 120,
          scopedSlots: { customRender: 'catalogId' }
        },
        {
          title: '千擎类型',
          dataIndex: 'lineType',
          width: 160
        },
        {
          title: '更新时间',
          dataIndex: 'syncTime',
          width: 180,
          scopedSlots: { customRender: 'syncTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 160,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    getCatalogName (catalogId) {
      if (catalogId == null || catalogId === '') return ''
      const item = this.catalogOptions.find(opt => String(opt.value) === String(catalogId))
      return item ? item.label : catalogId
    },
    formatSyncTime (value) {
      if (!value) return ''
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    loadDataList (params) {
      return this.getHttpServices()
        .getSourceService()
        .post('/qianqing/syncRecord/list', this.buildListParams(params))
        .then(this.normalizePageResult)
    },
    onToggleShield (record) {
      const isShielded = !!record.shielded
      this.requestPost(
        isShielded ? '/qianqing/syncShield/unshield' : '/qianqing/syncShield/shield',
        this.buildLineParams(record),
        {
          successMsg: isShielded ? '解除屏蔽成功' : '屏蔽成功',
          failMsg: isShielded ? '解除屏蔽失败，请重试' : '屏蔽失败，请重试'
        }
      )
    },
    onManualUpdate (record) {
      this.requestPost(
        '/qianqing/syncRecord/manualSync',
        this.buildLineParams(record),
        {
          successMsg: '手动更新成功',
          failMsg: '手动更新失败，请重试'
        }
      )
    }
  }
}
</script>

<style scoped lang="less">
.qianqing-product-update {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.action-block {
  color: #f5222d;
}

.ellipsis-cell {
  width: 448px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
